import styled from 'styled-components'

const StyledCoursePreviewView = styled.div`
  h1 {
    max-width: 700px;
    margin: 0 auto;
  }

  h2 {
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.07rem;
    color: ${({ theme }) => theme.colors.gray[500]};
    line-height: unset;
  }

  .course-top-bar {
    display: flex;
    justify-content: space-between;

    .btn {
      margin-left: -15px;
    }
  }

  .width-controller {
    padding: 20px 20px 60px 20px;
  }

  .video-player {
    margin-top: 1rem;
  }

  .course-details {
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.01rem;
    color: ${({ theme }) => theme.colors.gray[600]};
    text-align: center;
    margin: 45px 0 35px 0;
    display: grid;
    grid-gap: 10px;

    h1 {
      font-weight: 500;
      font-size: 32px;
      line-height: 45px;
      letter-spacing: 0.01rem;
      color: ${({ theme }) => theme.colors.gray[700]};
    }

    mark {
      color: ${({ theme }) => theme.colors.green[500]};
      background-color: transparent;
    }

    .bullet {
      width: 4px;
      height: 4px;
      display: inline-block;
      background: ${({ theme }) => theme.colors.gray[300]};
      border-radius: 50%;
      margin: 0 10px;
      vertical-align: middle;
    }
  }

  .course-description {
    font-weight: 600;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01rem;
    color: ${({ theme }) => theme.colors.gray[700]};
    max-width: 650px;
    margin: 0 auto;
  }

  .course-actions {
    display: flex;
    align-items: center;
    justify-content: end;
    margin-top: 25px;

    .course-preview-btn {
      display: grid;
      justify-items: center;
      grid-gap: 5px;
      height: fit-content;
      padding: 5px;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }

    .course-cart-info {
      display: flex;
      align-items: center;

      .pricing-total {
        font-weight: 500;
        font-size: 20px;
        color: ${({ theme }) => theme.colors.gray[700]};
      }

      .pricing-discount {
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.1px;
        color: ${({ theme }) => theme.colors.gray[400]};
        text-decoration: line-through;
        margin-left: 6px;
      }

      .btn {
        margin-left: 25px;
      }
    }

    .share-btn {
      margin-left: 1rem;
    }
  }

  .course-section {
    margin-top: 45px;
    padding-top: 45px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray[300]};

    h2 + .module-preview-row {
      margin-top: 25px;
    }
  }

  .course-breakdown {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-gap: 45px;

    .course-bullets-container {
      .course-bullets {
        padding: 0;
        margin: 25px 0 0 0;
        display: grid;
        grid-gap: 18px;
        list-style-type: none;

        li {
          display: flex;
          color: ${({ theme }) => theme.colors.gray[700]};
          font-weight: 500;
          line-height: 23px;

          svg {
            height: 24px;
            flex-shrink: 0;
            margin-right: 1rem;
          }
        }
      }
    }
  }

  .course-lessons {
    padding: 0;
    margin: 25px 0 0 0;
    display: grid;
    grid-gap: 20px;
    list-style-type: none;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    transition: 0.2s;
  }

  .course-floating-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    margin: 80px -20px 0 -20px;
    border-top: 1px solid  ${({ theme }) => theme.colors.gray[300]};
    position: sticky;
    bottom: 0;
    background: ${({ theme }) => theme.colors.background};
    pointer-events: none;

    .pricing-total {
      font-weight: 500;
      font-size: 20px;
      color: ${({ theme }) => theme.colors.gray[700]};
    }

    .pricing-discount {
      font-weight: 600;
      font-size: 14px;
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.colors.gray[400]};
      text-decoration: line-through;
      margin-left: 6px;
    }

    .btn {
      margin-left: 25px;
      pointer-events: all;
    }
  }

  @media (min-width: ${({ theme }) => `${theme.breakpoints.m}px`}) {
    .course-floating-bar {
      border-top: 0;
      margin: 80px 0 0 0;
      justify-content: center;
      background: linear-gradient(0deg, ${({ theme }) => theme.colors.background} 10%, #ffffff00 80%);
      padding: 2rem;
      display: none;
    }
  }
`

export default StyledCoursePreviewView
